import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SkipForward = function SkipForward(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M19 5v14M7.5995 17.9204l5.8388-4.671c.5338-.4271.8007-.6406.8974-.8986a1 1 0 0 0 0-.7016c-.0967-.258-.3636-.4715-.8974-.8986l-5.8388-4.671c-.8322-.6657-1.2482-.9986-1.5984-.999a1 1 0 0 0-.7826.3762C5 5.7304 5 6.2633 5 7.329v9.342c0 1.0657 0 1.5985.2185 1.8722a1 1 0 0 0 .7826.3762c.3502-.0004.7662-.3333 1.5984-.999"
    })
  }));
};
export default SkipForward;